export default __webpack_public_path__ + "static/media/019-usb connector.e872d9eb.svg";